var visuallyHiddenStyles = {"visuallyHidden":"VisuallyHidden-module_visuallyHidden__3fRX1"};

export { visuallyHiddenStyles as default };
//# sourceMappingURL=VisuallyHidden.module.css.js.map
